import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "checkbox" };
const _hoisted_2 = ["id", "disabled", "required"];
const _hoisted_3 = ["for"];
import { ref, watch } from 'vue';
import log from "../../services/Logger";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlBool',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const model = ref(props.data);
        const fieldOptions = props.field.options || {};
        watch(() => props.data, updateModel);
        function updateModel() {
            if (props.data === undefined || props.data === null || props.data === '') {
                model.value = undefined;
            }
            else if (props.data === 'true') {
                model.value = true;
            }
            else if (props.data === 'false') {
                model.value = false;
            }
            else {
                model.value = !!props.data;
            }
        }
        function onChange() {
            log('FieldControlBool@change', props.field.name, model.value);
            emit('change', model.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                    onChange: onChange,
                    type: "checkbox",
                    id: __props.fieldId,
                    disabled: _unref(fieldOptions).disabled ?? undefined,
                    required: _unref(fieldOptions).required ?? undefined,
                    class: "form__control"
                }, null, 40, _hoisted_2), [
                    [_vModelCheckbox, model.value]
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("label", { for: __props.fieldId }, null, 8, _hoisted_3)
            ]));
        };
    }
});
